import { useAuthContext } from '@/context/AuthContext';

const useResolvedUserDisplayName = (): string | undefined => {
  const { userInfo } = useAuthContext();
  const firstName = userInfo?.firstName?.trim();
  const lastName = userInfo?.lastName?.trim();

  const fullName = [firstName, lastName].filter(Boolean).join(' ').trim();

  if (fullName) {
    return fullName;
  }

  const username = userInfo?.username?.trim();

  return username || undefined;
};

export default useResolvedUserDisplayName;
